export default __webpack_public_path__ + "static/media/phone-booking-refresh.60c274e1.svg";